/**
 * Type guard function that checks if a value is an array.
 * Returns true if the value is an array, false otherwise.
 *
 * @param value - The value to check
 * @returns True if the value is an array, false otherwise
 *
 * @example
 * ```ts
 * import { IsArray } from "@pdfking/tfunc"
 *
 * const arr = [1, 2, 3];
 * const str = "hello";
 *
 * if (IsArray(arr)) {
 *   console.log(arr.length); // 3 (type narrowed to array)
 * }
 *
 * if (IsArray(str)) {
 *   // This block won't execute
 * }
 *
 * // Use in conditional logic
 * const value = IsArray(input) ? input : [input];
 * ```
 */
export const IsArray = Array.isArray
